import { ModuleState } from '@gongxigames/framework/slot/fragments/module/ModuleState';
import { ReelsEvents } from '@gongxigames/framework/slot/modules/reels/ReelsEvents';
import { LogicEvents } from '@gongxigames/framework/slot/services/logic/LogicEvents';
import {
    MultiSetsMulticampaignPromotionModule,
    MultiSetsMulticampaignPromotionModuleEvents,
    MultiSetsMulticampaignPromotionStates,
} from '@gongxigames/framework/promotions';

export class MultiSetsMulticampaignLastPromotionState extends ModuleState<
    null,
    MultiSetsMulticampaignPromotionModule,
    MultiSetsMulticampaignPromotionModuleEvents
> {
    private isFinished = false;

    public onEnterState(): void {
        this.isFinished = false;
    }

    public onLeaveState(): void {
        this.emit('Autoplay.FORCE_STOP');
        this.emit('General.Promotion.DeactivateCounter');
    }

    protected setupEvents(): void {
        this.setEventHandler(ReelsEvents.ALL_REELS_STOPPED, this.onAllReelsStopped.bind(this));
        this.setEventHandler('General.Flow.PAID_ROUND_ENDED', this.onPaidRoundEnded.bind(this));
        this.setEventHandler(LogicEvents.RESPONSE, this.onResponse.bind(this));
    }

    protected onAllReelsStopped(): void {
        this.emit('Autoplay.FORCE_STOP');
    }

    protected onPaidRoundEnded(): void {
        if (this.module.getPromotion().isEndOfPromotion() && !this.isFinished) {
            this.isFinished = true;
            this.module.gotoState(MultiSetsMulticampaignPromotionStates.END);
        }
    }

    private onResponse(): void {
        if (this.module.getPromotion().isEndOfPromotion()) {
            this.emit('General.Slot.SPIN.DISABLE', MultiSetsMulticampaignPromotionModule.NAME);
        }
    }
}
